import { render, staticRenderFns } from "./EntriesMassAssignmentNotifications.vue?vue&type=template&id=301fcf99&scoped=true&"
import script from "./EntriesMassAssignmentNotifications.vue?vue&type=script&lang=js&"
export * from "./EntriesMassAssignmentNotifications.vue?vue&type=script&lang=js&"
import style0 from "./EntriesMassAssignmentNotifications.vue?vue&type=style&index=0&id=301fcf99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301fcf99",
  null
  
)

export default component.exports